export const ugandaDistricts = [
  'Abim', 'Adjumani', 'Agago', 'Alebtong', 'Amolatar', 'Amudat', 'Amuria', 'Amuru', 'Apac',
  'Arua', 'Budaka', 'Bududa', 'Bugiri', 'Buhweju', 'Buikwe', 'Bukedea', 'Bukomansimbi',
  'Bukwo', 'Bulambuli', 'Buliisa', 'Bundibugyo', 'Bunyangabu', 'Busia', 'Butaleja', 'Butambala',
  'Butebo', 'Buvuma', 'Buyende', 'Dokolo', 'Gomba', 'Gulu', 'Hoima', 'Ibanda', 'Iganga',
  'Isingiro', 'Jinja', 'Kaabong', 'Kabale', 'Kabarole', 'Kaberamaido', 'Kagadi', 'Kakumiro',
  'Kalaki', 'Kalangala', 'Kaliro', 'Kalungu', 'Kampala', 'Kamuli', 'Kamwenge', 'Kanungu',
  'Kapchorwa', 'Kapelebyong', 'Kasese', 'Kassanda', 'Katakwi', 'Kayunga', 'Kibaale', 'Kiboga',
  'Kibuku', 'Kiruhura', 'Kiryandongo', 'Kisoro', 'Kitagwenda', 'Kitgum', 'Koboko', 'Kole',
  'Kotido', 'Kumi', 'Kween', 'Kwania', 'Kyankwanzi', 'Kyegegwa', 'Kyenjojo', 'Lamwo', 'Lira',
  'Luuka', 'Luwero', 'Lwengo', 'Lyantonde', 'Madi-Okollo', 'Manafwa', 'Maracha', 'Masaka',
  'Masindi', 'Mayuge', 'Mbale', 'Mbarara', 'Mitooma', 'Mityana', 'Moroto', 'Moyo', 'Mpigi',
  'Mubende', 'Mukono', 'Nabilatuk', 'Nakapiripirit', 'Nakaseke', 'Nakasongola', 'Namayingo',
  'Namisindwa', 'Namutumba', 'Napak', 'Nebbi', 'Ngora', 'Ntoroko', 'Ntungamo', 'Nwoya',
  'Obongi', 'Otuke', 'Oyam', 'Pader', 'Pallisa', 'Rakai', 'Rubirizi', 'Rukiga', 'Rukungiri',
  'Rwampara', 'Sembabule', 'Serere', 'Sheema', 'Sironko', 'Soroti', 'Terego', 'Tororo',
  'Wakiso', 'Yumbe', 'Zombo'
];

export const ugandaDistrictsByRegion = {
  Central: [
    'Kampala', 'Wakiso', 'Mukono', 'Mpigi', 'Luwero', 'Butambala', 'Gomba', 'Kalungu',
    'Kalangala', 'Mityana', 'Mubende', 'Kiboga', 'Kyankwanzi', 'Nakaseke', 'Nakasongola',
    'Buvuma', 'Buikwe', 'Kayunga', 'Kassanda'
  ],
  Eastern: [
    'Jinja', 'Iganga', 'Kamuli', 'Mayuge', 'Bugiri', 'Busia', 'Namutumba', 'Kaliro',
    'Budaka', 'Pallisa', 'Kibuku', 'Butaleja', 'Butebo', 'Bududa', 'Manafwa', 'Mbale',
    'Sironko', 'Bulambuli', 'Kapchorwa', 'Kween', 'Bukwo', 'Tororo', 'Namisindwa',
    'Serere', 'Amuria', 'Katakwi', 'Soroti', 'Ngora', 'Kumi', 'Amolatar', 'Dokolo',
    'Lira', 'Oyam', 'Kole', 'Alebtong', 'Otuke', 'Apac', 'Kwania'
  ],
  Northern: [
    'Gulu', 'Amuru', 'Nwoya', 'Oyam', 'Kole', 'Alebtong', 'Lira', 'Dokolo', 'Otuke',
    'Amolatar', 'Kitgum', 'Lamwo', 'Pader', 'Agago', 'Omoro', 'Arua', 'Maracha',
    'Koboko', 'Yumbe', 'Moyo', 'Adjumani', 'Obongi', 'Nebbi', 'Zombo', 'Pakwach',
    'Nabilatuk', 'Napak', 'Kaabong', 'Kotido', 'Abim', 'Nakapiripirit', 'Moroto', 'Amudat',
    'Karenga'
  ],
  Western: [
    ...new Set([
      'Mbarara', 'Isingiro', 'Kiruhura', 'Lyantonde', 'Rakai', 'Sembabule', 'Lwengo',
      'Masaka', 'Kalungu', 'Bukomansimbi', 'Kyotera', 'Kalangala', 'Kiboga', 'Kyegegwa',
      'Kyenjojo', 'Kabarole', 'Kamwenge', 'Bundibugyo', 'Ntoroko', 'Kasese', 'Buhweju',
      'Mitooma', 'Rubirizi', 'Sheema', 'Rwampara', 'Ibanda', 'Kazo', 'Kyegegwa',
      'Buhweju', 'Rubirizi', 'Sheema', 'Mitooma', 'Ibanda', 'Kamwenge', 'Kyegegwa',
      'Kyenjojo', 'Kagadi', 'Kakumiro', 'Kibaale', 'Kibuku', 'Kagadi', 'Kakumiro',
      'Kibaale', 'Kibuku', 'Kakumiro', 'Kagadi', 'Kyegegwa', 'Kyenjojo', 'Bundibugyo',
      'Ntoroko', 'Kasese', 'Buhweju', 'Mitooma', 'Rubirizi', 'Sheema', 'Rwampara', 'Ibanda',
      'Kamwenge', 'Kyegegwa', 'Kyenjojo', 'Kitagwenda', 'Madi-Okollo', 'Terego'
    ])
  ],
  Karamoja: [
    'Kaabong', 'Kotido', 'Abim', 'Nakapiripirit', 'Moroto', 'Napak', 'Amudat', 'Nabilatuk',
    'Karenga'
  ]
};
